export default __webpack_public_path__ + "static/media/j_sova_palena-min.b2dd6798.jpg";